import utils from 'utils/MiscUtils'

function hasGlobalDragCooldown() {
  return document.body?.dataset.dragCooldown === 'true'
}

function isEditingInFrame(targetFrameId) {
  const targetFrame = document.getElementById(targetFrameId)
  const globalDragCooldown = hasGlobalDragCooldown()
  if (!targetFrame)
    return globalDragCooldown

  const isDragging = targetFrame.querySelector('.ui-sortable-helper, .ui-draggable-dragging')
                    || targetFrame.querySelector('.sortable-ghost, .sortable-chosen, .sortable-drag')
                    || targetFrame.querySelector('[data-dragging="true"]')
                    || targetFrame.dataset.dragCooldown === 'true'
                    || targetFrame.querySelector('[data-drag-cooldown="true"]')

  const activeElement = document.activeElement
  const isActiveElementEditing = activeElement && targetFrame.contains(activeElement) && (
    activeElement.tagName === 'INPUT'
    || activeElement.tagName === 'TEXTAREA'
    || activeElement.tagName === 'SELECT'
    || activeElement.contentEditable === 'true'
  )

  const hasOpenDropdown = document.querySelector('.dropdown-menu.show, .modal.show')

  return !!(isDragging || isActiveElementEditing || hasOpenDropdown || globalDragCooldown)
}

function createCooldownHandler(cooldownMs = 3000) {
  let cooldownPromise = Promise.resolve()
  let pendingHandler = null
  let isScheduled = false

  return (eventHandler) => {
    pendingHandler = eventHandler

    if (!isScheduled) {
      isScheduled = true

      cooldownPromise = cooldownPromise.then(async () => {
        const handlerToExecute = pendingHandler
        pendingHandler = null
        isScheduled = false

        if (handlerToExecute) {
          handlerToExecute()
          await new Promise((resolve) => {
            setTimeout(resolve, cooldownMs)
          })
        }
      })
    }
  }
}

function reloadFrame(targetId) {
  const frame = document.getElementById(targetId)
  if (!frame)
    return
  if (frame.dataset?.disablePusherRefresh === 'true')
    return
  if (!frame.src && frame.dataset?.refreshUrl)
    frame.src = frame.dataset.refreshUrl
  if (frame.reload)
    frame.reload()
}

function dispatchBroadcast(payload) {
  if (typeof payload === 'string') {
    if (!hasGlobalDragCooldown())
      document.body?.insertAdjacentHTML('beforeend', payload)
    return
  }

  switch (payload.delivery) {
    case 'turbo-stream':
      if (!hasGlobalDragCooldown())
        document.body?.insertAdjacentHTML('beforeend', payload.html)
      break

    case 'frame-reload': {
      const targets = payload.targets || (payload.target ? [payload.target] : [])
      targets.forEach((targetId) => {
        if (isEditingInFrame(targetId))
          return
        reloadFrame(targetId)
      })
      break
    }

    default:
      utils.warn('Unknown broadcast delivery type:', payload.delivery)
  }
}

function setupPusherStreams(gfApp) {
  if (!gfApp || !gfApp.current_organization_id) {
    utils.warn('Cannot setup pusher streams without gfApp and organization ID')
    return
  }

  const orgChannel = gfApp.comm.subscribe({name: 'organization', id: gfApp.current_organization_id})

  const handleRefreshWithCooldown = createCooldownHandler(3000)

  orgChannel.bind('hotwire:inject', (payload) => {
    dispatchBroadcast(payload)
  })

  orgChannel.bind('gf:turboRefresh', (data) => {
    handleRefreshWithCooldown(() => {
      if (isEditingInFrame(data.target))
        return
      reloadFrame(data.target)
    })
  })
}

export {dispatchBroadcast}
export default {setupPusherStreams, dispatchBroadcast}
